import { makeStyles } from '@mui/styles';
import Modal from 'apollo-react/components/Modal';
import React, { useState } from 'react';

import ZoomTable from './ZoomTable';
import { useTranslation } from '../../../custom-hooks/useTranslation';
import { useWindowDimensions } from '../../../custom-hooks/useWindowDimensions';
import { getUITA, removeCurrentPageSelection } from '../../../utils/commonUtils';

const useStyles = makeStyles({
  zoomDialogPaperFullWidth: {
    maxWidth: '90%',
  },
  muiDialogContent: {
    '& [class*="MuiDialogContent"]': {
      maxWidth: 'unset',
    },
    '& [class*="MuiDialogActions"]': {
      marginBottom: 20,
      marginTop: 5,
    },
  },
});

const ZoomDialog = ({
  open,
  onClose,
  multiSelect = false,
  entityName,
  dataKey = '',
  customFilter = [],
  initialSearchName,
  onSelect,
  referencedColumns = {},
  dynamicParamCollection = {},
  title = '',
  translatedSearchName,
  dataLookUpType,
}) => {
  const { isMobileDevice } = useWindowDimensions();
  const classes = useStyles();
  const translateString = useTranslation();
  const [selections, setSelections] = useState([]);

  const handleSelectClick = () => {
    onSelect(selections);
    setSelections([]);
  };

  const handleMultiSelect = (checked, row) => {
    const newSelections = checked
      ? [...selections, row]
      : selections.filter((s) =>
          Boolean(row.PrimaryKeyColumn) && Boolean(s.PrimaryKeyColumn)
            ? s[s.PrimaryKeyColumn] !== row[row.PrimaryKeyColumn]
            : JSON.stringify(s) !== JSON.stringify(row)
        );

    setSelections(newSelections);
  };

  const handleHeaderMultiselect = (
    allRowsPerPage,
    isAllRecordsPerPageSelected,
    isSelectedRecordOnCurrentPage
  ) => {
    if (
      (isSelectedRecordOnCurrentPage && !isAllRecordsPerPageSelected) ||
      isAllRecordsPerPageSelected
    ) {
      const filteredSelections = removeCurrentPageSelection(allRowsPerPage, selections);
      setSelections(filteredSelections);
      return;
    }

    setSelections([...selections, ...allRowsPerPage]);
  };

  const cancelButton = { label: translateString('Cancel'), onClick: onClose };
  const buttonProps = multiSelect
    ? [cancelButton, { label: translateString('Select'), onClick: handleSelectClick }]
    : [cancelButton];

  return (
    <Modal
      open={open}
      title={title}
      classes={{
        paperFullWidth: classes.zoomDialogPaperFullWidth,
        paper: classes.muiDialogContent,
      }}
      onClose={onClose}
      PaperProps={{
        style: { margin: isMobileDevice ? 16 : 32 },
        'ui-ta': getUITA('SSZoomDialog'),
      }}
      fullWidth={!isMobileDevice}
      disableEnforceFocus
      disableBackdropClick
      disableEscapeKeyDown
      buttonProps={buttonProps}
    >
      <span ui-ta={getUITA('SSZoomTable')}>
        <ZoomTable
          entityName={entityName}
          initialSearchName={initialSearchName}
          translatedSearchName={translatedSearchName}
          dataKey={dataKey}
          dataLookUpType={dataLookUpType}
          onSingleSelect={onSelect}
          multiSelect={multiSelect}
          selections={selections}
          customFilter={customFilter}
          onMultiSelect={handleMultiSelect}
          onHeaderMultiselect={handleHeaderMultiselect}
          referencedColumns={referencedColumns}
          dynamicParamCollection={dynamicParamCollection}
        />
      </span>
    </Modal>
  );
};

export default ZoomDialog;
